import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  loggedIn: false,
  data: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateLogin: (state, action) => {
      state.loggedIn = true;
      state.data = action.payload;
    },
    logout: (state, action) => {
      state.loggedIn = false;
      state.data = null;
    },
  },
});

export const { updateLogin, logout } = authSlice.actions;
export default authSlice.reducer;
